import Text from '@components/Text';
import colors from '@constants/colors';
import { Trans } from 'react-i18next';

import styles from './styles.module.scss';

function OrderNote() {
    return (
        <div className={styles.container}>
            <Text color={colors.gray6} className={styles.text}>
                <Trans ns="orderLog" i18nKey="note.pushNotification" components={{ br: <br /> }} />
            </Text>
        </div>
    );
}

export default OrderNote;
